import { render, staticRenderFns } from "./CampaignPublishedPage.vue?vue&type=template&id=666815fc&scoped=true&"
import script from "./CampaignPublishedPage.vue?vue&type=script&lang=js&"
export * from "./CampaignPublishedPage.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPublishedPage.vue?vue&type=style&index=0&id=666815fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666815fc",
  null
  
)

export default component.exports